module.exports = __webpack_public_path__ + "static/media/usevilla.1a7045fa.png";